module.exports = "\n<div class=\"comp-accordion-toggle\" v-on:click.prevent.stop=\"onClick\">\n  <slot></slot>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./assets/js/frontend/components/accordion_toggle/index.pug
// module id = 672
// module chunks = 4